const MUSIC_VERB_KEYS = {
    watched: 'common:playback.played',
    watchTime: 'common:labels.listenTime',
};
/** Translation keys for the "watched" and "watch time" wording, by media type. */
export const MEDIA_VERB_KEYS = {
    track: MUSIC_VERB_KEYS,
    album: MUSIC_VERB_KEYS,
    artist: MUSIC_VERB_KEYS,
    default: {
        watched: 'common:playback.watched',
        watchTime: 'common:labels.watchTime',
    },
};
export function verbKeysFor(mediaType) {
    return mediaType && Object.hasOwn(MEDIA_VERB_KEYS, mediaType)
        ? MEDIA_VERB_KEYS[mediaType]
        : MEDIA_VERB_KEYS.default;
}
//# sourceMappingURL=mediaVerbs.js.map